var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgVideo = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5BEE",
    stroke: "#5C5BEE",
    strokeWidth: 0.125,
    d: "m18.409 9.046-.031-.054.03.054 3.75-2.143a.688.688 0 0 1 1.03.597v9a.688.688 0 0 1-1.03.597l-3.75-2.143-.03.054.03-.054a.69.69 0 0 1-.346-.597V9.643a.69.69 0 0 1 .347-.597Zm-1.971-.42v8.999A1.44 1.44 0 0 1 15 19.063H4.5a3.69 3.69 0 0 1-3.687-3.688v-9A1.44 1.44 0 0 1 2.25 4.938h10.5a3.69 3.69 0 0 1 3.688 3.687Z"
  })));
};
const Memo = /*#__PURE__*/memo(SvgVideo);
export default Memo;